import { motion } from 'framer-motion';

import { CexPair } from 'entities/cex';
import { IFilterSchemeExtended, IFilterValue } from 'types/filters/common';
import { ICexPair } from 'types/pairs';
import { EExchange } from 'web3';

import { FilterConnection } from '../FilterConnection';
import { FilterSelectType } from '../FilterSelectType';
import { FilterValue } from '../FilterValue';

import { TrashIcon } from 'assets/icons';

interface IFilterItemProps {
  filter: IFilterValue;
  filters: IFilterValue[];
  scheme: Record<string, IFilterSchemeExtended>;
  updateFilter: (id: string, filter?: IFilterValue) => void;
  deleteFilter: (id: string) => void;
  exchange?: EExchange | undefined;
  cexPair?: CexPair | ICexPair | null;
}

function FilterItem({
  filter,
  filters,
  scheme,
  updateFilter,
  deleteFilter,
  exchange,
  cexPair,
}: IFilterItemProps) {
  return (
    <div className="mm-filter-item_container">
      <div className="filter-fields">
        <FilterSelectType
          filters={filters}
          filter={filter}
          scheme={scheme}
          updateFilter={updateFilter}
        />
        <FilterConnection filter={filter} type={filter.type} updateFilter={updateFilter} />
        <FilterValue
          filter={filter}
          type={filter.type}
          updateFilter={updateFilter}
          exchange={exchange}
          cexPair={cexPair}
        />
      </div>
      <motion.button className="delete-filter" onClick={() => deleteFilter(filter.id)}>
        <TrashIcon />
      </motion.button>
    </div>
  );
}

export default FilterItem;
